export const ModalConfigratoinData = {
  /** Eoi-History Component */
  EOi_Confirmation_Dialog_Data: {
    message: 'Do you want to close this EOI?',
    header: 'Confirmation',
  },
  ITT_Confirmation_Dialog_Data: {
    message: 'Do you want to close this ITT?',
    header: 'Confirmation',
  },
  Drawing_Confirmation: {
    message:
      'Based on the number you provided,we can adjust the number of the rest of the drawing revision in this upload with greater accuracy .Would uou like us to apply these changes?',
    header: 'Readjust subsequent drawing number',
  },
};
